/* components/ui/Drawer.jsx — универсальный правый Drawer-хром (без доменного контента).
   Три уровня стека (data-level 1/2/3): backdrop затемняет level-1,
   уровни 2/3 сдвигают предыдущий. Размеры sm/md/lg/xl/full (xl — 1180px, панели-отчёты
   на всю таблицу: «Столы» Аналитики).
   На ≤720px → 100vw fullscreen. z-index: var(--z-drawer-1/2/3).
   slide-in-right (motion-токены). focus-trap, scroll-lock (только level=1), ESC. */

import React from 'react';
import ReactDOM from 'react-dom';
import { Icon } from './Icon.jsx';
import { getOverlayRoot, overlay } from '../../lib/overlay.jsx';

  const { useRef } = React;
  const { useFocusTrap, useScrollLock } = overlay;

  function Drawer({ open, onClose, title, size = 'md', level = 1, children, footer,
                    showBack = false, onBack, breadcrumbs, closeOnBackdrop = true, hideTitle = false }) {
    const panelRef = useRef(null);
    useScrollLock(open && level === 1);
    useFocusTrap(panelRef, { active: open, onEscape: onClose });
    if (!open) return null;

    const zVar = level === 3 ? 'var(--z-drawer-3)' : level === 2 ? 'var(--z-drawer-2)' : 'var(--z-drawer-1)';

    return ReactDOM.createPortal(
      <div className="overlay overlay--drawer" data-level={level} style={{ zIndex: zVar }}>
        {level === 1 && <div className="overlay__backdrop" onClick={closeOnBackdrop ? onClose : undefined} />}
        <aside className={`drawer drawer--${size}`} data-level={level}
               role="dialog" aria-modal={level === 1 ? 'true' : undefined}
               aria-label={typeof title === 'string' ? title : undefined} ref={panelRef}>
          <div className="drawer__head">
            <div className="drawer__head-left cluster cluster-3 grow">
              {showBack && (
                <button className="drawer__back" onClick={onBack} aria-label="Назад">
                  <Icon name="arrow-left" size={18} />
                </button>
              )}
              <div className="stack stack-2 grow">
                {breadcrumbs && <div className="drawer__crumbs t-caption truncate">{breadcrumbs}</div>}
                {title && !hideTitle && <h2 className="drawer__title t-h3 truncate">{title}</h2>}
              </div>
            </div>
            <button className="drawer__close" onClick={onClose} aria-label="Закрыть">
              <Icon name="close" size={18} />
            </button>
          </div>
          <div className="drawer__body">{children}</div>
          {footer && <div className="drawer__foot cluster cluster-4">{footer}</div>}
        </aside>
      </div>,
      getOverlayRoot()
    );
  }

export { Drawer };
